/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CephTracing/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import No from './No/index'
import PerformTrace from './PerformTrace/index'
import React from 'react'
import ViewTraces from './ViewTraces/index'



/** @type {import('Simple/types.js').View} */
export default function CephTracing({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PerformTrace'}>
<PerformTrace
  viewPath={`${viewPath}/PerformTrace`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ViewTraces'}>
<ViewTraces
  viewPath={`${viewPath}/ViewTraces`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}